export const IS_PRODUCTION = process.env.VUE_APP_PRODUCTION === "production";

export const HTTP_HEADER_SKIP_ERROR = "UT-Skip-Error";
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
};

export const AUTH_COOKIE = {
  name: "s_cms_auth_token",
  path: "/"
};
export const SOCK_COOKIE = {
  name: "s_cms_sock_token",
  path: "/"
};
export const SITE_INFO = {
  name: "s_cms_site_info",
  path: "/"
};

export const STORAGE_ITEM = {
  time: 's_cms_keyExpireDate'
}


export const DOCUMENT_TITLE_PREFIX = "SUPER SENIOR";

export const GAME_CODE_NAME = {
  kp: "카지노게임",
  kps: "슬롯게임"
};

export const RATE_INCREASE = 0.05;

export const GAME_INFO_LIST = {
  casino: {
    1: "evol",
    10: "cn_pp",
    12: "playtech",
    13: "hotel",
    2: "big",
    5: "aisa",
    6: "dream",
    9: "sexy"
  },
  slot: {
    200: "slot_pp",
    201: "slot_habanero",
    202: "slot_elysium",
    204: "slot_quick",
    205: "slot_spade",
    207: "slot_ray",
    208: "slot_world",
    209: "slot_micro",
    212: "slot_yl",
    213: "slot_evo",
    214: "slot_netant",
    215: "slot_dragon",
    216: "slot_gg",
    217: "slot_boongo",
    218: "slot_playson",
    219: "slot_playtech",
    220: "slot_cq9",
    221: "slot_sky"
  },
  sport: {
    sp: "sp"
  },
  minigame: {
    mg: "mg",
    kino:"kino",
    powerball:"powerball"
  },
  fishing: {
    1000: "fishing"
  },
  kiron: {
    102: "kiron"
  },
  esport: {
    101: "esport"
  }
};

export const GAME_LOBBY_CODE = {
  slot: "0",
  fishing: "1000"
};

export const PARTNER_TYPE = {
  senior: "시니어",
  master: "마스터",
  agency: "에이전시"
};
